import { render, staticRenderFns } from "./CPUChart.vue?vue&type=template&id=71ccfdab&scoped=true&"
import script from "./CPUChart.vue?vue&type=script&lang=js&"
export * from "./CPUChart.vue?vue&type=script&lang=js&"
import style0 from "./CPUChart.vue?vue&type=style&index=0&id=71ccfdab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ccfdab",
  null
  
)

export default component.exports